import { Component } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { NgFor, NgIf } from '@angular/common';
import { ZikataToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'zikatagov-toasts',
  standalone: true,
  imports: [NgbToastModule, NgFor, NgIf],
  template: `
    <ngb-toast
      *ngFor="let toast of toastService.toasts"
      [class]="toast.classname"
      [autohide]="!toast.sticky"
      [delay]="toast.delay"
      (hidden)="toastService.remove(toast)"
    >
      <div class="d-flex align-items-center justify-content-between gap-2">
        <span>{{ toast.text }}</span>
        <button
          *ngIf="toast.sticky || toast.dismissible"
          type="button"
          class="btn-close flex-shrink-0"
          [class.btn-close-white]="!toast.classname.includes('text-dark')"
          aria-label="Dismiss"
          (click)="toastService.remove(toast)"
        ></button>
      </div>
    </ngb-toast>
  `,
  host: {
    class: 'toast-container position-fixed top-0 end-0 p-3',
    style: 'z-index: 1200',
  },
})
export class ZikataToastContainerComponent {
  constructor(public toastService: ZikataToastService) {}
}